import React, { useState } from 'react';
import { Calendar, FileText, Download, User, LogOut, Bell, CheckCircle, Clock, Leaf } from 'lucide-react';
const collections = [{
  id: 'COL-001',
  date: '28 Nov 2024',
  time: '9am–12pm',
  service: 'Commercial Waste Collection',
  status: 'Confirmed',
  address: '12 High Street, Chingford E4 7AB'
}, {
  id: 'COL-002',
  date: '5 Dec 2024',
  time: '7am–9am',
  service: 'Commercial Waste Collection',
  status: 'Scheduled',
  address: '12 High Street, Chingford E4 7AB'
}, {
  id: 'COL-003',
  date: '12 Dec 2024',
  time: '9am–12pm',
  service: 'Commercial Waste Collection',
  status: 'Scheduled',
  address: '12 High Street, Chingford E4 7AB'
}];
const invoices = [{
  id: 'INV-2024-089',
  date: '1 Nov 2024',
  amount: '£240.00',
  status: 'Paid',
  service: 'Monthly Contract – November'
}, {
  id: 'INV-2024-076',
  date: '1 Oct 2024',
  amount: '£240.00',
  status: 'Paid',
  service: 'Monthly Contract – October'
}, {
  id: 'INV-2024-063',
  date: '1 Sep 2024',
  amount: '£240.00',
  status: 'Paid',
  service: 'Monthly Contract – September'
}];
const documents = [{
  name: 'Waste Transfer Note – Nov 2024',
  date: '1 Nov 2024',
  type: 'PDF'
}, {
  name: 'Waste Transfer Note – Oct 2024',
  date: '1 Oct 2024',
  type: 'PDF'
}, {
  name: 'Eco Recycling Report – Q3 2024',
  date: '1 Oct 2024',
  type: 'PDF'
}];
export function CustomerPortalPage() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [activeTab, setActiveTab] = useState<'collections' | 'invoices' | 'documents'>('collections');
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setLoggedIn(true);
  };
  if (!loggedIn) {
    return <div className="pt-16 lg:pt-20 min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-528">
        <div className="w-full max-w-md" data-id="element-529">
          <div className="text-center mb-8" data-id="element-530">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{
            backgroundColor: '#1B8F4B'
          }} data-id="element-531">
              <Leaf className="w-8 h-8 text-white" data-id="element-532" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-533">
              Customer Portal
            </h1>
            <p className="text-gray-500 mt-1 text-sm" data-id="element-534">
              Sign in to manage your collections and invoices
            </p>
          </div>
          <form onSubmit={handleLogin} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 space-y-5" data-id="element-535">
            <div data-id="element-536">
              <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-537">
                Email Address
              </label>
              <input type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm" data-id="element-538" />
            </div>
            <div data-id="element-539">
              <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-540">
                Password
              </label>
              <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm" data-id="element-541" />
            </div>
            <button type="submit" className="w-full py-4 rounded-xl font-bold text-white transition-all duration-200 hover:opacity-90" style={{
            backgroundColor: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-542">
              Sign In
            </button>
            <p className="text-center text-xs text-gray-400" data-id="element-543">
              Demo: click Sign In with any credentials
            </p>
          </form>
        </div>
      </div>;
  }
  return <div className="pt-16 lg:pt-20 min-h-screen bg-gray-50" data-id="element-544">
      {/* Portal Header */}
      <div className="bg-white border-b border-gray-200 px-4 py-4" data-id="element-545">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-546">
          <div data-id="element-547">
            <h1 className="text-xl font-bold text-gray-900" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-548">
              Welcome back, Premier Property Management
            </h1>
            <p className="text-sm text-gray-500" data-id="element-549">
              Monthly Contract Customer · Account No. ACC-2024-042
            </p>
          </div>
          <div className="flex items-center gap-3" data-id="element-550">
            <button className="p-2 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-551">
              <Bell className="w-5 h-5 text-gray-500" data-id="element-552" />
            </button>
            <button onClick={() => setLoggedIn(false)} className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-553">
              <LogOut className="w-4 h-4" data-id="element-554" /> Sign Out
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-555">
        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8" data-id="element-556">
          {[{
          icon: Calendar,
          label: 'Next Collection',
          value: '28 Nov 2024',
          color: '#1B8F4B'
        }, {
          icon: FileText,
          label: 'Invoices This Year',
          value: '11 invoices',
          color: '#3B82F6'
        }, {
          icon: Leaf,
          label: 'Tonnes Recycled',
          value: '4.2 tonnes',
          color: '#1B8F4B'
        }].map(({
          icon: Icon,
          label,
          value,
          color
        }) => <div key={label} className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-557">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{
            backgroundColor: `${color}15`
          }} data-id="element-558">
                <Icon className="w-6 h-6" style={{
              color
            }} data-id="element-559" />
              </div>
              <div data-id="element-560">
                <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider" data-id="element-561">
                  {label}
                </p>
                <p className="font-bold text-gray-900" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-562">
                  {value}
                </p>
              </div>
            </div>)}
        </div>

        {/* Account Manager */}
        <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm mb-8 flex items-center gap-4" data-id="element-563">
          <div className="w-12 h-12 rounded-full overflow-hidden" data-id="element-564">
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&auto=format&fit=crop&facepad=3&fit=facearea" alt="Account manager" className="w-full h-full object-cover" data-id="element-565" />
          </div>
          <div className="flex-1" data-id="element-566">
            <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider" data-id="element-567">
              Your Account Manager
            </p>
            <p className="font-bold text-gray-900" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-568">
              Priya Sharma
            </p>
            <p className="text-sm text-gray-500" data-id="element-569">
              priya@talkinrubbish.com · 07405 641227 ext. 2
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm font-semibold" style={{
          color: '#1B8F4B'
        }} data-id="element-570">
            <div className="w-2 h-2 rounded-full bg-green-400" data-id="element-571" />
            Available
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-572">
          <div className="flex border-b border-gray-100" data-id="element-573">
            {[{
            key: 'collections',
            label: 'Upcoming Collections',
            icon: Calendar
          }, {
            key: 'invoices',
            label: 'Invoices',
            icon: FileText
          }, {
            key: 'documents',
            label: 'Documents',
            icon: Download
          }].map(({
            key,
            label,
            icon: Icon
          }) => <button key={key} onClick={() => setActiveTab(key as typeof activeTab)} className="flex items-center gap-2 px-6 py-4 text-sm font-semibold border-b-2 transition-all duration-200" style={{
            borderBottomColor: activeTab === key ? '#1B8F4B' : 'transparent',
            color: activeTab === key ? '#1B8F4B' : '#6B7280'
          }} data-id="element-574">
                <Icon className="w-4 h-4" data-id="element-575" /> {label}
              </button>)}
          </div>

          <div className="p-6" data-id="element-576">
            {activeTab === 'collections' && <div className="space-y-3" data-id="element-577">
                {collections.map(c => <div key={c.id} className="flex items-center gap-4 p-4 rounded-xl border border-gray-100 hover:border-[#1B8F4B] transition-colors" data-id="element-578">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#F0FDF4'
              }} data-id="element-579">
                      {c.status === 'Confirmed' ? <CheckCircle className="w-5 h-5" style={{
                  color: '#1B8F4B'
                }} data-id="element-580" /> : <Clock className="w-5 h-5" style={{
                  color: '#F59E0B'
                }} data-id="element-581" />}
                    </div>
                    <div className="flex-1" data-id="element-582">
                      <p className="font-semibold text-gray-900 text-sm" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-583">
                        {c.service}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-584">
                        {c.date} · {c.time} · {c.address}
                      </p>
                    </div>
                    <span className="px-3 py-1 rounded-full text-xs font-bold" style={{
                backgroundColor: c.status === 'Confirmed' ? '#F0FDF4' : '#FFFBEB',
                color: c.status === 'Confirmed' ? '#1B8F4B' : '#F59E0B'
              }} data-id="element-585">
                      {c.status}
                    </span>
                  </div>)}
              </div>}

            {activeTab === 'invoices' && <div className="space-y-3" data-id="element-586">
                {invoices.map(inv => <div key={inv.id} className="flex items-center gap-4 p-4 rounded-xl border border-gray-100" data-id="element-587">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#EFF6FF'
              }} data-id="element-588">
                      <FileText className="w-5 h-5 text-blue-500" data-id="element-589" />
                    </div>
                    <div className="flex-1" data-id="element-590">
                      <p className="font-semibold text-gray-900 text-sm" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-591">
                        {inv.id}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-592">
                        {inv.service} · {inv.date}
                      </p>
                    </div>
                    <span className="font-bold text-gray-900 text-sm" data-id="element-593">
                      {inv.amount}
                    </span>
                    <span className="px-3 py-1 rounded-full text-xs font-bold bg-green-50" style={{
                color: '#1B8F4B'
              }} data-id="element-594">
                      {inv.status}
                    </span>
                    <button className="p-2 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-595">
                      <Download className="w-4 h-4 text-gray-400" data-id="element-596" />
                    </button>
                  </div>)}
              </div>}

            {activeTab === 'documents' && <div className="space-y-3" data-id="element-597">
                {documents.map(doc => <div key={doc.name} className="flex items-center gap-4 p-4 rounded-xl border border-gray-100" data-id="element-598">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#FEF3C7'
              }} data-id="element-599">
                      <FileText className="w-5 h-5 text-amber-500" data-id="element-600" />
                    </div>
                    <div className="flex-1" data-id="element-601">
                      <p className="font-semibold text-gray-900 text-sm" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-602">
                        {doc.name}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-603">
                        {doc.date} · {doc.type}
                      </p>
                    </div>
                    <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors hover:bg-gray-100" style={{
                color: '#1B8F4B'
              }} data-id="element-604">
                      <Download className="w-4 h-4" data-id="element-605" /> Download
                    </button>
                  </div>)}
              </div>}
          </div>
        </div>
      </div>
    </div>;
}